import routerOptions0 from "/builds/bunuble/bunuble/bunuble/node_modules/.pnpm/nuxt@3.16.2_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.14.1_db0@0.3.1_es_cf531f2dcd08b1b73ac12f0d8cc6bafc/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/builds/bunuble/bunuble/bunuble/node_modules/.pnpm/@nuxt+ui-pro@1.7.1_jwt-decode@4.0.0_magicast@0.3.5_qrcode@1.5.4_typescript@5.8.3_vite@6_f99455f8bf99dd0b7275ca7258470907/node_modules/@nuxt/ui-pro/modules/pro/runtime/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}